import React from "react";
import {SelectOption} from "@/types";

type Props = {
    options: SelectOption[];
    selected: string[];
    sonota_text: string;
    project_detail_section_error?: string;
    setValue: (name: string, value: string | boolean) => void;
};

export const ProjectDetailSection = ({
                                         options,
                                         selected,
                                         sonota_text,
                                         project_detail_section_error,
                                         setValue
                                     }: Props) => {
    return (
        <div className="form-flex">
            <div className="form-flex-txt">対応種別<span>（複数選択可）</span></div>
            <div className="form-flex-input">
                <div className={`form_project_detail_section form-flex-input-checkbox${project_detail_section_error ? ' form-input-error' : ''}`}>
                    {options.map((option) => (
                        <label key={option.id}>
                            <input
                                type="checkbox"
                                name="project_detail_section"
                                value={option.id}
                                checked={selected.includes(option.id)}
                                onChange={() => setValue('project_detail_section', option.id)}
                            /> {option.name}
                            {option.name === 'その他' && (
                                <input type="text"
                                       name="project_detail_section_other_text"
                                       value={sonota_text}
                                       onChange={(e) => setValue('project_detail_section_other_text', e.target.value)}
                                />
                            )}
                        </label>
                    ))}
                </div>
                {project_detail_section_error &&
                    <span className="form-error-message">{project_detail_section_error}</span>}
            </div>
        </div>
    );
};
